import React from "react";
import { Link } from "react-router-dom";

const DisplayHouse = () => {
  return (
    <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Check Our Display Houses
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Display House 1 */}
        <Link
          className="border border-gray-200 rounded-lg overflow-hidden shadow-sm transition-all duration-300 hover:border-orange-500 hover:shadow-md"
          to="https://maps.app.goo.gl/F1BAMhtEaxM6Q8gE8"
        >
          <div className="flex">
            {/* Left side - Image */}
            <div className="w-1/3">
              <img
                src="https://media.istockphoto.com/id/1319190739/photo/modern-home-cross-section-night-scene-3d-rendering.jpg?s=612x612&w=0&k=20&c=Y7JofX4eJHEUEmsdCgEvn-ffUDp7oo1aNC16L9_SPFQ="
                alt="Display House Gallery"
                className="w-full h-full object-cover bg-gray-200 transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            {/* Right side - Content */}
            <div className="w-2/3 p-4">
              {/* Logo and Number */}
              <div className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <div className="bg-red-500 w-6 h-6 rounded-sm rotate-45 flex items-center justify-center mr-1">
                    <span className="text-white text-xs font-bold -rotate-45">
                      B
                    </span>
                  </div>
                  <span className="font-semibold text-gray-700">BricknBar</span>
                </div>
                <span className="text-2xl font-bold">1</span>
              </div>

              {/* Tagline */}
              <div className="text-sm text-gray-500 mb-1">MAKE HOME EASY</div>

              {/* Main content */}
              <div className="mb-3">
                <h2 className="text-xl font-semibold">
                  Visit Our{" "}
                  <span className="text-orange-500">Display House.</span>
                </h2>
              </div>

              {/* Address */}
              <p className="text-gray-500 text-sm">
                Plot No: K4-891, 2nd Floor, Kalinga Vihar, Bhubaneswar, 751019.
              </p>
            </div>
          </div>
        </Link>

        {/* Display House 2 */}
        <Link
          className="border border-gray-200 rounded-lg overflow-hidden shadow-sm transition-all duration-300 hover:border-orange-500 hover:shadow-md cursor-pointer"
          to="https://maps.app.goo.gl/F1BAMhtEaxM6Q8gE8"
        >
          <div className="flex">
            {/* Left side - Image */}
            <div className="w-1/3">
              <img
                src="https://media.istockphoto.com/id/1319190739/photo/modern-home-cross-section-night-scene-3d-rendering.jpg?s=612x612&w=0&k=20&c=Y7JofX4eJHEUEmsdCgEvn-ffUDp7oo1aNC16L9_SPFQ="
                alt="Display House Gallery"
                className="w-full h-full object-cover bg-gray-200 transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            {/* Right side - Content */}
            <div className="w-2/3 p-4">
              {/* Logo and Number */}
              <div className="flex justify-between items-center mb-2">
                <div className="flex items-center">
                  <div className="bg-red-500 w-6 h-6 rounded-sm rotate-45 flex items-center justify-center mr-1">
                    <span className="text-white text-xs font-bold -rotate-45">
                      B
                    </span>
                  </div>
                  <span className="font-semibold text-gray-700">BricknBar</span>
                </div>
                <span className="text-2xl font-bold">2</span>
              </div>

              {/* Tagline */}
              <div className="text-sm text-gray-500 mb-1">MAKE HOME EASY</div>

              {/* Main content */}
              <div className="mb-3">
                <h2 className="text-xl font-semibold">
                  Visit Our{" "}
                  <span className="text-orange-500">Display House.</span>
                </h2>
              </div>

              {/* Address */}
              <p className="text-gray-500 text-sm">
                Plot No: K4-891, 2nd Floor, Kalinga Vihar, Bhubaneswar, 751019.
              </p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default DisplayHouse;
